<section>
  <div class="container" style="padding-top: 90px !important;">
    <div class="sombra">
      <div class="row" style="margin-right: 0px;">
        <div
          class="col-3"
          style="background: #fbfbfb; padding:20px; border-radius: 1%;  border: 3px solid #00365F;"
        >
          <div class="d-flex justify-content-center">
            <div>
              <h1 style="margin-bottom: 0px !important;">
                {{ gridsize.value != 0 ? gridsize.value : 5 }}
              </h1>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div><label>empleados</label></div>
          </div>
          <div class="d-flex justify-content-center">
            <div *ngIf="this.currentSlide < 1">
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value <= 10"
              >
                {{
                  gridsize.value > 0 && gridsize.value <= 10
                    ? (gridsize.value * diezMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 10 && gridsize.value <= 20"
              >
                {{
                  gridsize.value > 10 && gridsize.value <= 20
                    ? (20 * veinteMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 20 && gridsize.value <= 30"
              >
                {{
                  gridsize.value > 20 && gridsize.value <= 30
                    ? (30 * treintaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 30 && gridsize.value <= 50"
              >
                {{
                  gridsize.value > 30 && gridsize.value <= 50
                    ? (50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 50 && gridsize.value <= 55"
              >
                {{
                  gridsize.value > 50 && gridsize.value <= 55
                    ? (5 * diezMes + 50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 55 && gridsize.value <= 60"
              >
                {{
                  gridsize.value > 55 && gridsize.value <= 60
                    ? (10 * diezMes + 50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 60 && gridsize.value <= 70"
              >
                {{
                  gridsize.value > 60 && gridsize.value <= 70
                    ? (20 * veinteMes + 50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 70 && gridsize.value <= 80"
              >
                {{
                  gridsize.value > 70 && gridsize.value <= 80
                    ? (30 * treintaMes + 50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 80 && gridsize.value <= 100"
              >
                {{
                  gridsize.value > 80 && gridsize.value <= 100
                    ? (50 * cincuentaMes + 50 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 100 && gridsize.value <= 105"
              >
                {{
                  gridsize.value > 100 && gridsize.value <= 105
                    ? (5 * diezMes + 100 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 105 && gridsize.value <= 110"
              >
                {{
                  gridsize.value > 105 && gridsize.value <= 110
                    ? (10 * diezMes + 100 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 110 && gridsize.value <= 120"
              >
                {{
                  gridsize.value > 110 && gridsize.value <= 120
                    ? (20 * veinteMes + 100 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 120 && gridsize.value <= 130"
              >
                {{
                  gridsize.value > 120 && gridsize.value <= 130
                    ? (30 * treintaMes + 100 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 130 && gridsize.value <= 150"
              >
                {{
                  gridsize.value > 130 && gridsize.value <= 150
                    ? (50 * cincuentaMes + 100 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 150 && gridsize.value <= 155"
              >
                {{
                  gridsize.value > 150 && gridsize.value <= 155
                    ? (5 * diezMes + 150 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 155 && gridsize.value <= 160"
              >
                {{
                  gridsize.value > 155 && gridsize.value <= 160
                    ? (10 * diezMes + 150 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 160 && gridsize.value <= 170"
              >
                {{
                  gridsize.value > 160 && gridsize.value <= 170
                    ? (20 * veinteMes + 150 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 170 && gridsize.value <= 180"
              >
                {{
                  gridsize.value > 170 && gridsize.value <= 180
                    ? (30 * treintaMes + 150 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 180 && gridsize.value <= 200"
              >
                {{
                  gridsize.value > 180 && gridsize.value <= 200
                    ? (50 * cincuentaMes + 150 * cincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
            </div>
            <div *ngIf="this.currentSlide >= 1">
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value <= 5"
              >
                {{
                  gridsize.value > 0 && gridsize.value <= 5
                    ? (cincoAnyo | number: '1.2')
                    : (150 | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 5 && gridsize.value <= 10"
              >
                {{
                  gridsize.value > 5 && gridsize.value <= 10
                    ? (diezAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 10 && gridsize.value <= 20"
              >
                {{
                  gridsize.value > 10 && gridsize.value <= 20
                    ? (veinteAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 20 && gridsize.value <= 30"
              >
                {{
                  gridsize.value > 20 && gridsize.value <= 30
                    ? (treintaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 30 && gridsize.value <= 50"
              >
                {{
                  gridsize.value > 30 && gridsize.value <= 50
                    ? (cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 50 && gridsize.value <= 55"
              >
                {{
                  gridsize.value > 50 && gridsize.value <= 55
                    ? (cincoAnyo + cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 55 && gridsize.value <= 60"
              >
                {{
                  gridsize.value > 55 && gridsize.value <= 60
                    ? (diezAnyo + cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 60 && gridsize.value <= 70"
              >
                {{
                  gridsize.value > 60 && gridsize.value <= 70
                    ? (veinteAnyo + cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 70 && gridsize.value <= 80"
              >
                {{
                  gridsize.value > 70 && gridsize.value <= 80
                    ? (treintaAnyo + cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 80 && gridsize.value <= 100"
              >
                {{
                  gridsize.value > 80 && gridsize.value <= 100
                    ? (cincuentaAnyo + cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 100 && gridsize.value <= 105"
              >
                {{
                  gridsize.value > 100 && gridsize.value <= 105
                    ? (cincoAnyo + 2 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 105 && gridsize.value <= 110"
              >
                {{
                  gridsize.value > 105 && gridsize.value <= 110
                    ? (diezAnyo + 2 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 110 && gridsize.value <= 120"
              >
                {{
                  gridsize.value > 110 && gridsize.value <= 120
                    ? (veinteAnyo + 2 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 120 && gridsize.value <= 130"
              >
                {{
                  gridsize.value > 120 && gridsize.value <= 130
                    ? (treintaAnyo + 2 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 130 && gridsize.value <= 150"
              >
                {{
                  gridsize.value > 130 && gridsize.value <= 150
                    ? (cincuentaAnyo + 2 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 150 && gridsize.value <= 155"
              >
                {{
                  gridsize.value > 150 && gridsize.value <= 155
                    ? (cincoAnyo + 3 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 155 && gridsize.value <= 160"
              >
                {{
                  gridsize.value > 155 && gridsize.value <= 160
                    ? (diezAnyo + 3 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 160 && gridsize.value <= 170"
              >
                {{
                  gridsize.value > 160 && gridsize.value <= 170
                    ? (veinteAnyo + 3 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 170 && gridsize.value <= 180"
              >
                {{
                  gridsize.value > 170 && gridsize.value <= 180
                    ? (treintaAnyo + 3 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
              <h1
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 180 && gridsize.value <= 200"
              >
                {{
                  gridsize.value > 180 && gridsize.value <= 200
                    ? (cincuentaAnyo + 3 * cincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€
              </h1>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div *ngIf="this.currentSlide < 1">
              <!-- <label>IVA no incluido</label> -->
            </div>
            <div *ngIf="this.currentSlide >= 1">
              <!-- <label>IVA no incluido </label> -->
            </div>
          </div>
          <div
            *ngIf="this.currentSlide < 1"
            class="d-flex justify-content-center"
          >
            <div>
              <small style="margin-bottom: 0px !important;">
                IVA no incluido
              </small>
            </div>
            <!-- <div>
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value <= 5"
              >
                {{
                  gridsize.value > 0 && gridsize.value <= 5
                    ? (totalcincoAnyo | number: '1.2')
                    : (180 | number: '1.2')
                }}€
              </small>
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 5 && gridsize.value <= 10"
              >
                {{
                  gridsize.value > 5 && gridsize.value <= 10
                    ? (totaldiezAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 10 && gridsize.value <= 20"
              >
                {{
                  gridsize.value > 10 && gridsize.value <= 20
                    ? (totalveinteAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 20 && gridsize.value <= 30"
              >
                {{
                  gridsize.value > 20 && gridsize.value <= 30
                    ? (totaltreintaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 30 && gridsize.value <= 50"
              >
                {{
                  gridsize.value > 30 && gridsize.value <= 50
                    ? (totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 50 && gridsize.value <= 55"
              >
                {{
                  gridsize.value > 50 && gridsize.value <= 55
                    ? (totalcincoAnyo + totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 55 && gridsize.value <= 60"
              >
                {{
                  gridsize.value > 55 && gridsize.value <= 60
                    ? (totaldiezAnyo + totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 60 && gridsize.value <= 70"
              >
                {{
                  gridsize.value > 60 && gridsize.value <= 70
                    ? (totalveinteAnyo + totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 70 && gridsize.value <= 80"
              >
                {{
                  gridsize.value > 70 && gridsize.value <= 80
                    ? (totaltreintaAnyo + totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 80 && gridsize.value <= 100"
              >
                {{
                  gridsize.value > 80 && gridsize.value <= 100
                    ? (totalcincuentaAnyo + totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 100 && gridsize.value <= 105"
              >
                {{
                  gridsize.value > 100 && gridsize.value <= 105
                    ? (totalcincoAnyo + 2 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 105 && gridsize.value <= 110"
              >
                {{
                  gridsize.value > 105 && gridsize.value <= 110
                    ? (totaldiezAnyo + 2 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 110 && gridsize.value <= 120"
              >
                {{
                  gridsize.value > 110 && gridsize.value <= 120
                    ? (totalveinteAnyo + 2 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 120 && gridsize.value <= 130"
              >
                {{
                  gridsize.value > 120 && gridsize.value <= 130
                    ? (totaltreintaAnyo + 2 * totalcincuentaAnyo
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 130 && gridsize.value <= 150"
              >
                {{
                  gridsize.value > 130 && gridsize.value <= 150
                    ? (totalcincuentaAnyo + 2 * totalcincuentaAnyo
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 150 && gridsize.value <= 155"
              >
                {{
                  gridsize.value > 150 && gridsize.value <= 155
                    ? (totalcincoAnyo + 3 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 155 && gridsize.value <= 160"
              >
                {{
                  gridsize.value > 155 && gridsize.value <= 160
                    ? (totaldiezAnyo + 3 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 160 && gridsize.value <= 170"
              >
                {{
                  gridsize.value > 160 && gridsize.value <= 170
                    ? (totalveinteAnyo + 3 * totalcincuentaAnyo | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 170 && gridsize.value <= 180"
              >
                {{
                  gridsize.value > 170 && gridsize.value <= 180
                    ? (totaltreintaAnyo + 3 * totalcincuentaAnyo
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 180 && gridsize.value <= 200"
              >
                {{
                  gridsize.value > 180 && gridsize.value <= 200
                    ? (totalcincuentaAnyo + 3 * totalcincuentaAnyo
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€</small
              >
            </div> -->
          </div>
          <div
            *ngIf="this.currentSlide >= 1"
            class="d-flex justify-content-center"
          >
            <div>
              <small style="margin-bottom: 0px !important;">
                IVA no incluido
              </small>
            </div>
            <!-- <div>
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value <= 5"
              >
                {{
                  gridsize.value > 0 && gridsize.value <= 5
                    ? (totalcincoMes | number: '1.2')
                    : (15 | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 5 && gridsize.value <= 10"
              >
                {{
                  gridsize.value > 5 && gridsize.value <= 10
                    ? (totaldiezMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 10 && gridsize.value <= 20"
              >
                {{
                  gridsize.value > 10 && gridsize.value <= 20
                    ? (totalveinteMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 20 && gridsize.value <= 30"
              >
                {{
                  gridsize.value > 20 && gridsize.value <= 30
                    ? (totaltreintaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 30 && gridsize.value <= 50"
              >
                {{
                  gridsize.value > 30 && gridsize.value <= 50
                    ? (totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 50 && gridsize.value <= 55"
              >
                {{
                  gridsize.value > 50 && gridsize.value <= 55
                    ? (totalcincoMes + totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 55 && gridsize.value <= 60"
              >
                {{
                  gridsize.value > 55 && gridsize.value <= 60
                    ? (totaldiezMes + totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 60 && gridsize.value <= 70"
              >
                {{
                  gridsize.value > 60 && gridsize.value <= 70
                    ? (totalveinteMes + totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 70 && gridsize.value <= 80"
              >
                {{
                  gridsize.value > 70 && gridsize.value <= 80
                    ? (totaltreintaMes + totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 80 && gridsize.value <= 100"
              >
                {{
                  gridsize.value > 80 && gridsize.value <= 100
                    ? (totalcincuentaMes + totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 100 && gridsize.value <= 105"
              >
                {{
                  gridsize.value > 100 && gridsize.value <= 105
                    ? (totalcincoMes + 2 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 105 && gridsize.value <= 110"
              >
                {{
                  gridsize.value > 105 && gridsize.value <= 110
                    ? (totaldiezMes + 2 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 110 && gridsize.value <= 120"
              >
                {{
                  gridsize.value > 110 && gridsize.value <= 120
                    ? (totalveinteMes + 2 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 120 && gridsize.value <= 130"
              >
                {{
                  gridsize.value > 120 && gridsize.value <= 130
                    ? (totaltreintaMes + 2 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 130 && gridsize.value <= 150"
              >
                {{
                  gridsize.value > 130 && gridsize.value <= 150
                    ? (totalcincuentaMes + 2 * totalcincuentaMes
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 150 && gridsize.value <= 155"
              >
                {{
                  gridsize.value > 150 && gridsize.value <= 155
                    ? (totalcincoMes + 3 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 155 && gridsize.value <= 160"
              >
                {{
                  gridsize.value > 155 && gridsize.value <= 160
                    ? (totaldiezMes + 3 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 160 && gridsize.value <= 170"
              >
                {{
                  gridsize.value > 160 && gridsize.value <= 170
                    ? (totalveinteMes + 3 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 170 && gridsize.value <= 180"
              >
                {{
                  gridsize.value > 170 && gridsize.value <= 180
                    ? (totaltreintaMes + 3 * totalcincuentaMes | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes€</small
              >
              <small
                style="margin-bottom: 0px !important;"
                *ngIf="gridsize.value > 180 && gridsize.value <= 200"
              >
                {{
                  gridsize.value > 180 && gridsize.value <= 200
                    ? (totalcincuentaMes + 3 * totalcincuentaMes
                      | number: '1.2')
                    : (precio | number: '1.2')
                }}€ al mes</small
              >
            </div> -->
          </div>
          <!-- <div *ngIf="this.currentSlide >= 1">
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value <= 5"
            >
              Ahorra
              {{
                gridsize.value > 0 && gridsize.value <= 5
                  ? (totalcincoAnyo - cincoAnyo | number: '1.2')
                  : (30 | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 5 && gridsize.value <= 10"
            >
              Ahorra
              {{
                gridsize.value > 5 && gridsize.value <= 10
                  ? (totaldiezAnyo - diezAnyo | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 10 && gridsize.value <= 20"
            >
              Ahorra
              {{
                gridsize.value > 10 && gridsize.value <= 20
                  ? (totalveinteAnyo - veinteAnyo | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 20 && gridsize.value <= 30"
            >
              Ahorra
              {{
                gridsize.value > 20 && gridsize.value <= 30
                  ? (totaltreintaAnyo - treintaAnyo | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 30 && gridsize.value <= 50"
            >
              Ahorra
              {{
                gridsize.value > 30 && gridsize.value <= 50
                  ? (totalcincuentaAnyo - cincuentaAnyo | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 50 && gridsize.value <= 55"
            >
              Ahorra
              {{
                gridsize.value > 50 && gridsize.value <= 55
                  ? (totalcincoAnyo -
                      cincoAnyo +
                      (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 55 && gridsize.value <= 60"
            >
              Ahorra
              {{
                gridsize.value > 55 && gridsize.value <= 60
                  ? (totaldiezAnyo -
                      diezAnyo +
                      (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 60 && gridsize.value <= 70"
            >
              Ahorra
              {{
                gridsize.value > 60 && gridsize.value <= 70
                  ? (totalveinteAnyo -
                      veinteAnyo +
                      (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 70 && gridsize.value <= 80"
            >
              Ahorra
              {{
                gridsize.value > 70 && gridsize.value <= 80
                  ? (totaltreintaAnyo -
                      treintaAnyo +
                      (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 80 && gridsize.value <= 100"
            >
              Ahorra
              {{
                gridsize.value > 80 && gridsize.value <= 100
                  ? (2 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 100 && gridsize.value <= 105"
            >
              Ahorra
              {{
                gridsize.value > 100 && gridsize.value <= 105
                  ? (totalcincoAnyo -
                      cincoAnyo +
                      2 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 105 && gridsize.value <= 110"
            >
              Ahorra
              {{
                gridsize.value > 105 && gridsize.value <= 110
                  ? (totaldiezAnyo -
                      diezAnyo +
                      2 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 110 && gridsize.value <= 120"
            >
              Ahorra
              {{
                gridsize.value > 110 && gridsize.value <= 120
                  ? (totalveinteAnyo -
                      veinteAnyo +
                      2 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 120 && gridsize.value <= 130"
            >
              Ahorra
              {{
                gridsize.value > 120 && gridsize.value <= 130
                  ? (totaltreintaAnyo -
                      treintaAnyo +
                      2 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 130 && gridsize.value <= 150"
            >
              Ahorra
              {{
                gridsize.value > 130 && gridsize.value <= 150
                  ? (3 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 150 && gridsize.value <= 155"
            >
              Ahorra
              {{
                gridsize.value > 150 && gridsize.value <= 155
                  ? (totalcincoAnyo -
                      cincoAnyo +
                      3 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 155 && gridsize.value <= 160"
            >
              Ahorra
              {{
                gridsize.value > 155 && gridsize.value <= 160
                  ? (totaldiezAnyo -
                      diezAnyo +
                      3 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 160 && gridsize.value <= 170"
            >
              Ahorra
              {{
                gridsize.value > 160 && gridsize.value <= 170
                  ? (totalveinteAnyo -
                      veinteAnyo +
                      3 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 170 && gridsize.value <= 180"
            >
              Ahorra
              {{
                gridsize.value > 170 && gridsize.value <= 180
                  ? (totaltreintaAnyo -
                      treintaAnyo +
                      3 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
            <small
              class="d-flex justify-content-center"
              style="padding:2px; background: rgb(238, 70, 70);color: #ffffff;"
              *ngIf="gridsize.value > 180 && gridsize.value <= 200"
            >
              Ahorra
              {{
                gridsize.value > 180 && gridsize.value <= 200
                  ? (4 * (totalcincuentaAnyo - cincuentaAnyo) | number: '1.2')
                  : (precio | number: '1.2')
              }}€</small
            >
          </div> -->
        </div>
        <div class="col-9 ">
          <div class="row">
            <div class="col-10 ">
              <nav
                class="slide nav nav-tabs nav-outlined nav-rounded mb-5"
                style="margin-bottom:25px !important; border-radius:opx !important; justify-content: normal !important;"
              >
                <a
                  class="nav-item nav-link"
                  [class.active]="i === currentSlide"
                  href="javascript:;"
                  (click)="updateSlider(i)"
                  *ngFor="let item of ['Mensual', 'Anual']; let i = index"
                >
                  {{ item }}
                </a>
              </nav>
            </div>
            <!-- <div class="col-2">
              <a
                href="/auth/register"
                style="margin-right: 10px; border: solid #DCC59C;"
                class="btn btn-info bold"
                >Contratar</a
              >
            </div> -->
          </div>
          <div>
            <h3>Indique los empleados de su empresa</h3>
          </div>
          <mat-slider
            style="width:100%;"
            #gridsize
            (change)="updateSetting($event)"
            max="200"
            min="5"
            step="5"
            thumbLabel="thumbLabel"
            value="valor"
            aria-labelledby="example-name-label"
          ></mat-slider>
          <div style="display:flex; justify-content:space-between;">
            <span class="text-sm font-bold my-2">5</span>
            <span class="text-sm font-bold my-2">50</span>
            <span class="text-sm font-bold my-2">100</span>
            <span class="text-sm font-bold my-2">150</span>
            <span class="text-sm font-bold my-2">200</span>
          </div>
        </div>
      </div>
      <div class="row" style="padding-top: 20px; padding-bottom: 10px;">
        <div class="col-12">
          <h5>¿Sois más de 200 empleados en vuestro negocio?</h5>
          <h5>
            Tenemos un precio especial para vosotros.
          </h5>
        </div>
        <!-- <div class="col-2">

          <small> * IVA no incluido </small>
        </div> -->
      </div>
      <div class="row">
        <div class="col-10">
          <a
            href="/contacto"
            class="btn btn-success bold"
            style="border: solid #DCC59C;"
            >Contacta con nosotros
          </a>
        </div>
        <div class="col-2">
          <a
            href="/auth/register"
            style="border: solid #DCC59C;"
            class="btn btn-info bold"
            >Contratar</a
          >
        </div>
      </div>
      <!-- <a  href="/contacto"
          class="btn btn-success bold"
          style="border: solid #DCC59C;"
          >Contacta con nosotros
      </a> -->
    </div>
  </div>
</section>
